import { OnlineUser, AuthApi, ResultResponse } from 'kiolyn-api';
import IAuthRepository from '../domain/repositories/IAuthRepository';

export default class AuthRepository implements IAuthRepository {
  private readonly api: AuthApi;

  constructor(basePath: string) {
    this.api = new AuthApi({
      basePath
    });
  }

  public async signUp(
    onlineUser: OnlineUser,
    storeid: string
  ): Promise<ResultResponse> {
    return (await this.api.signupUser(storeid, onlineUser)).data;
  }

  public async signIn(onlineUser: OnlineUser): Promise<OnlineUser> {
    return (await this.api.signinUser(onlineUser)).data;
  }
}
